import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'currentLang', // set locale
  fallbackLocale: 'currentLang',
  messages : {currentLang: LPT.config.translationMap}, // set locale messages
});



// WEBPACK FOOTER //
// ./src/global/i18n/index.js